export default __webpack_public_path__ + "static/media/active-clock-icon-sense.5309e556a3208b58168c9a2b36ad8ed3.svg";